module.exports = __webpack_public_path__ + "static/media/adminPanel.0eac6efd.svg";